export default "__VITE_ASSET__DF_mLcDP__"